var map = {
	"./theme1/auth/ForgotPassword.vue": [
		"c972",
		"chunk-663a4020"
	],
	"./theme2/auth/ForgotPassword.vue": [
		"508c",
		"chunk-e322375c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "45c4";
module.exports = webpackAsyncContext;